export const enum CostingStatus {
  Active = 'active',
  Pending = 'pending',
  Expired = 'expired',
}

export const enum FormType {
  PRICE = 'price',
  COST = 'cost',
}
